<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="s-tabs">

<!--<div v-for="(btn, index) in tabList" :key="btn.index">-->

        <!--<b-button-group>
            <b-button v-for="(btn, index) in tabList" :key="btn.index" class="btn" @click="_Value=index">
                {{$t(btn.name)}}
            </b-button>
        </b-button-group>-->

        <b-row class="rc" align="left">
            <b-col cols="12">
                <b-button v-for="(btn) in tabList" :key="btn.index" :class="value==btn.id ? 'btnSelect' : 'btn'" @click="_Value=btn.id">
                    {{$t(btn.name)}}
                </b-button>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'


export default{
    name: 's-tabs',
    components: {
        
},
    props: ['tabList', 'value'],
    data() {
        return {
            
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme', 'getLanguage']),
        _Value: {
            get: function() {return this.value},
            set: function(modifiedValue){this.$emit('update:value', modifiedValue)}
        }
    },
    watch: {
        
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/components/oTabs.scss'
</style>